import smoothScrollTo from 'src/utils/smoothScrollTo'
import getElementOffsetTop from 'src/utils/getElementOffsetTop'

function getStickyChromeOffset() {
  if (typeof document === 'undefined') {
    return 0
  }

  const headerEl = document.querySelector<HTMLElement>('.the-header__sticky-line')
  const headerHeight = headerEl?.offsetHeight || 0
  const sectionMenuEl = document.querySelector<HTMLElement>('.section-menu--pinned')
  const sectionMenuHeight = sectionMenuEl?.offsetHeight || 0
  const previewEl = document.querySelector<HTMLElement>('.preview-menu__bar')
  const previewHeight = previewEl?.offsetHeight || 0

  return headerHeight + sectionMenuHeight + previewHeight
}

/**
 * Скролл к селектору с учётом sticky-шапки и закреплённого меню.
 */
export default function smoothScrollToSelector(
  selector: string,
  options: { duration?: number } = {},
) {
  if (typeof document === 'undefined' || !selector) {
    return
  }

  const target = document.querySelector(selector)

  if (!target) {
    return
  }

  const targetTop = getElementOffsetTop(target) || 0
  const chromeOffset = getStickyChromeOffset()

  smoothScrollTo(Math.max(targetTop - chromeOffset, 0), {
    duration: options.duration ?? 1000,
    offset: 0,
  })
}
